module.exports = __webpack_public_path__ + "static/media/A4.f6bd2538.jpg";